import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import submit from "submit-form";

const OnboardingInfo = ({ locals, setOnboardingInfo }) => {
  const { athlete, onboardingQuestionnaire, workflows } = locals;

  const joinedAt = moment(athlete?.joinedAt);

  // moved up cuz it can be filled by stopped trainig or something
  if (onboardingQuestionnaire) {
    return (
      <article
        className="onboarding-card"
        onClick={() => {
          setOnboardingInfo(onboardingQuestionnaire);
        }}
      >
        <div>
          <div className="chip success">Completed</div>

          <SvgIcon src={"/img/new-icons/arrow-right.svg"} />
        </div>
        <p className="s1">Onboarding Questionnaire</p>
        <p className="p5">
          Check out the onboarding questionnaire filled by the client.
        </p>
      </article>
    );
  }

  // Cuz the onboarding is gonna release in like Feb 11 or something lol
  if (joinedAt.isBefore(moment("2025-01-01"))) {
    return null;
  }

  if (
    !(
      workflows.length > 0 &&
      workflows.find((workflow) => workflow.access === "pull")
    )
  ) {
    return (
      <article
        className="onboarding-card"
        onClick={() => {
          submit("/coaching-portal/custom-workflows", {
            body: {
              access: "pull",
            },
          });
        }}
      >
        <div>
          <div className="chip info">Create Now</div>

          <SvgIcon src={"/img/new-icons/arrow-right.svg"} />
        </div>
        <p className="s1">Onboarding Questionnaire</p>
        <p className="p5">
          Prompt your clients with onboarding questionnaire, for more
          information click here
        </p>
      </article>
    );
  }

  if (!onboardingQuestionnaire) {
    return (
      <article
        className="onboarding-card"
        onClick={() => {
          submit("/coaching-portal/custom-workflows", {
            body: {
              access: "pull",
              workflow: workflows.find((workflow) => workflow.access === "pull")
                ._id,
              type: "getting-started",
            },
          });
        }}
      >
        <div>
          <div className="chip warning">Pending</div>

          <SvgIcon src={"/img/new-icons/arrow-right.svg"} />
        </div>
        <p className="s1">Onboarding Questionnaire</p>
        <p className="p5">
          Prompt your clients with onboarding questionnaire, for more
          information click here
        </p>
      </article>
    );
  }

  return null;
};

OnboardingInfo.propTypes = {
  locals: PropTypes.object,
};

export default OnboardingInfo;
